// extracted by mini-css-extract-plugin
module.exports = {"pvfWrapper":"_3ts77","pvfNameTitle":"_2-aBK","pvfCustomTitle":"_2O62o"};